import { render, staticRenderFns } from "./MicroeconomicsDetailsTable.vue?vue&type=template&id=5050f29a&"
import script from "./MicroeconomicsDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./MicroeconomicsDetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports